// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/CriteriosAvaliacoes_ListResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /config/criterios_avaliacoes/list.
 *
 * Returns the list of evaluation criteria as produced by
 * Avaliacoes_model::listCriteria() (the external avaliacoesApi
 * `criteria/list` response `Data`). When the external service returns
 * nothing the list is empty.
 */
import type { CriteriosAvaliacoes_ListRow } from './CriteriosAvaliacoes_ListRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type CriteriosAvaliacoes_ListResponseDados = CriteriosAvaliacoes_ListRow[];

export type CriteriosAvaliacoes_ListResponse = ApiResponse<CriteriosAvaliacoes_ListResponseDados>;

registerResponseContract('CriteriosAvaliacoes_ListResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      ID:   { type: 'number',  required: true },
      name: { type: 'string',  required: true },
    },
  },
})
